import {
  AreaItemType,
  MetaItemType,
  type DraggableFieldType,
  type DraggableMetaType,
  type FieldWrapper,
  type ReportType,
} from "../../../../../../../../../api/types/svTypes.ts";
import { isAllowedInConditions } from "../../../../../utilities/conditionDataTypes.ts";
import { isAggregation } from "../../../../../utilities/fieldsHelper.ts";
import { extractMeta, isValueField } from "../../../common/utilities/dropFieldContainerHelper.ts";

export const canDropConditionItem = (
  item: FieldWrapper<DraggableFieldType> | DraggableMetaType,
  reportType?: ReportType
): boolean => {
  const meta = extractMeta(item);
  if (!meta || !isAllowedInConditions(meta, reportType)) {
    return false;
  }

  if (item.type === AreaItemType.VALUES) {
    return isValueField(item) && isAggregation(item.field);
  }

  return meta.itemType === MetaItemType.DIMENSION;
};
